import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import visaIcon from '../../assets/images/payment/visa-card.png'
import masterIcon from '../../assets/images/payment/master-card.png'
import aeIcon from '../../assets/images/payment/ae-card.png'
import alipayIcon from '../../assets/images/payment/alipay.png'
import wechatIcon from '../../assets/images/payment/wechat.png'
import paymeIcon from '../../assets/images/payment/payme.png'
import fpsIcon from '../../assets/images/payment/fps.png'
import walletIcon from '../../assets/images/payment/wallet.png'
import paypalIcon from '../../assets/images/payment/paypal.png'
import eddaIcon from '../../assets/images/payment/edda.png'

import tickIcon from '../../assets/images/common/tick.png'
import holdMoneyIcon from '../../assets/images/common/hold_money.png'

import MobileWrapper from '../../components/MobileWrapper'
import MobileHeader from '../../components/MobileHeader'
import MobileContent from '../../components/MobileContent'
import WhiteBox from '../../components/WhiteBox'
import QrCode from '../../components/QrCode'

import cautionIcon from '../../assets/images/payment/caution.png'
import itemIcon from '../../assets/images/common/item.png'
import replySlipPaymentIcon from '../../assets/images/payment/reply-slip-payment.png'
import { getInvoice } from '../../reducers/invoice'
import {
  FETCH_INVOICE,
  PAY_INVOICE,
  FETCH_PAYMENT_PARAMS,
  FETCH_PAYMENT_STATUS,
  CHANGE_METHOD,
  fetchInvoice,
  payInvoice,
  fetchPaymentParams,
  fetchPaymentStatus,
  changePayMethod,
} from '../../actions/invoice'
import { dateTimeFormatter, moneyFormatter } from '../../utils/formatter'
import DropDownSelect from '../../components/DropDownSelect'
import { getUser, getCreditCards } from '../../reducers/user'
import { FETCH_CREDIT_CARD, fetchCreditCards } from '../../actions/user'
import { reset } from '../../actions/selector'
import StyleButton from '../../components/StyleButton'
import LoadingSpinner from '../../components/LoadingSpinner'
import PopupModal from '../../components/PopupModal'
import TextInput from '../../components/TextInput'
import {
  createLoadingSelector,
  createSuccessSelector,
  createErrorMessageSelector,
} from '../../reducers/selector'
import { FETCH_PAYMENT_SERVICE_CHARGES, fetchPaymentServiceCharges } from '../../actions/school'
import { getPaymentServiceCharges } from '../../reducers/school'
import ClientEventHandler, {
  protocol as ClientEventHandlerProtocol,
} from '../../utils/clientEventHandler'

const styles = () => {
  return {
    paymentButtonContainer: {
      position: 'relative',
      height: '36px',
      padding: '20px',
    },
    paymentButton: {
      position: 'absolute',
      left: '25%',
      right: '25%',
      borderRadius: '50px',
      width: '50%',
      height: '36px',
      fontSize: '14px',
      color: 'white',
      border: 0,
      outline: 0,
    },
    totalContainer: {
      marginTop: '16px',
      fontWeight: 600,
      display: 'flex',
      justifyContent: 'space-between',
    },
    totalLabel: {
      float: 'left',
      textAlign: 'left',
    },
    totalAmount: {
      float: 'right',
      textAlign: 'right',
    },
    deadlineContainer: {
      marginTop: '16px',
      marginBottom: '16px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    deadlineLabel: {
      float: 'left',
      textAlign: 'left',
    },
    deadlineText: {
      float: 'right',
      textAlign: 'right',
    },
    invoiceDescriptionLabel: {
      textAlign: 'center',
      padding: '10px',
    },
    listItem: {
      paddingTop: '10px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingBottom: '10px',
      borderBottom: 'solid 1px #d2d2d2',
      position: 'relative',
    },
    listItemIconContainer: {
      top: '0px',
      left: '5px',
      position: 'absolute',
    },
    listItemIcon: {
      width: '45px',
      height: '45px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundImage: `url(${itemIcon})`,
      color: 'skyblue',
      fontWeight: 'bold',
      backgroundSize: '100%',
      fontSize: '14px',
    },
    listItemIconImage: {
      width: '45px',
      height: '45px',
    },
    listItemTitle: {
      fontWeight: 600,
    },
    listItemContent: {
      marginLeft: '50px',
    },
    listItemDescription: {
      fontWeight: 400,
      color: 'grey',
      fontSize: '14px',
    },
    popupModalButtonContainer: {
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    popupModalButton: {
      marginBottom: '5px',
    },
    fontLineThrough: {
      textDecoration: 'line-through',
    },
    fpsQrCodeContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      boxShadow: '0 3px 3px #D2D2D2',
      backgroundColor: 'white',
      borderRadius: '20px',
      marginTop: '16px',
    },
    fpsQrCodeLabel: {
      paddingTop: '24px',
      textAlign: 'center',
    },
    fpsNameLabel: {
      paddingTop: '24px',
    },
    payingButtonContainer: {
      position: 'relative',
      height: '120px',
      paddingTop: '16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-evenly',
    },
    payingButton: {
      width: '50%',
      height: '36px',
      fontSize: '14px',
      color: 'white',
    },
    paidContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '16px',
    },
    paidIconContainer: {
      height: '192px',
      width: '192px',
      position: 'relative',
    },
    paidIcon: {
      objectFit: 'contain',
      height: '178px',
      width: '178px',
    },
    paidTickContainer: {
      position: 'absolute',
      bottom: '0',
      right: '0',
    },
    paidTickIcon: {
      objectFit: 'contain',
      height: '48px',
      width: '48px',
      position: 'absolute',
      bottom: '0',
      right: '0',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    invoice: getInvoice(state),
    user: getUser(state),
    creditCards: getCreditCards(state),
    paymentServiceCharges: getPaymentServiceCharges(state),
    isFetchPaymentServiceChargesSuccess: createSuccessSelector([FETCH_PAYMENT_SERVICE_CHARGES])(
      state,
    ),
    isFetchInvoiceSuccess: createSuccessSelector([FETCH_INVOICE])(state),
    isFetchCreditCardSuccess: createSuccessSelector([FETCH_CREDIT_CARD])(state),
    isSubmitting: createLoadingSelector([
      FETCH_PAYMENT_PARAMS,
      FETCH_PAYMENT_STATUS,
      PAY_INVOICE,
      CHANGE_METHOD,
    ])(state),
    isPayInvoiceSuccess: createSuccessSelector([PAY_INVOICE, FETCH_PAYMENT_STATUS])(state),
    isQfPayFailed: createErrorMessageSelector([FETCH_PAYMENT_STATUS])(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoice(invoiceId) {
      return dispatch(fetchInvoice(invoiceId))
    },
    changePayMethod(invoiceId) {
      return dispatch(changePayMethod(invoiceId))
    },
    payInvoice(invoiceId, payload) {
      return dispatch(payInvoice(invoiceId, payload))
    },
    fetchPaymentParams(invoiceId, method, payload) {
      return dispatch(fetchPaymentParams(invoiceId, method, payload))
    },
    fetchPaymentStatus(invoiceId, payload) {
      return dispatch(fetchPaymentStatus(invoiceId, payload))
    },
    fetchCreditCards() {
      return dispatch(fetchCreditCards())
    },
    fetchPaymentServiceCharges() {
      return dispatch(fetchPaymentServiceCharges())
    },
    reset(type) {
      return dispatch(reset(type))
    },
  }
}

@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@withTranslation()
@injectSheet(styles)
class InvoicePage extends Component {
  state = {
    paymentMethod: 'wallet',
    selectedCreditCardId: null,
    displayNotEnoughPopup: false,
    displayPaySuccessPopup: false,
    displayQfPayFailedPopup: false,
    displayConfirmChangeMethodPopup: false,
    paymentServiceCharges: [],
    payeeName: '',
    paymentUrl: '',
    showWebView: false,
  }

  get creditCards() {
    const { creditCards, t } = this.props
    return [
      ...creditCards.map((creditCard) => {
        let png = null
        let name = ''
        switch (creditCard.brand) {
          case 'Visa':
            // icon = faCcVisa
            // iconColor = '#0157a2'
            name = 'Visa'
            png = visaIcon
            break
          case 'MasterCard':
            // icon = faCcMastercard
            // iconColor = '#F79E1B'
            name = 'Master'
            png = masterIcon
            break
          case 'American Express':
            // icon = faCcAmex
            // iconColor = '#007bc1'
            name = 'AE'
            png = aeIcon
            break
          default:
            break
        }
        return {
          name: `${name} - xxxx-xxxx-xxxx-${creditCard.card_last4}`,
          value: creditCard.id,
          // icon,
          // iconColor,
          png,
        }
      }),
      {
        name: t('new_credit_card'),
        value: 'NEW_CREDIT_CARD',
      },
    ]
  }

  get paymentMethods() {
    const { user, invoice, t } = this.props
    const { paymentServiceCharges } = this.props
    const supportMethods = [
      {
        type: 'paymentMethod',
        value: 'alipay_hk',
        name: `${t('alipay')} HK`,
        png: alipayIcon,
        // icon: faAlipay,
        // iconColor: '#64befa',
      },
      {
        type: 'paymentMethod',
        value: 'tng',
        name: 'TnG',
        // icon: faQrcode,
        // iconColor: '#4FC3F7',
      },
      {
        type: 'paymentMethod',
        value: 'fps_hase',
        name: `${t('fps')}`,
        png: fpsIcon,
      },
      {
        type: 'paymentMethod',
        value: 'payme',
        name: `${t('payme')}`,
        png: paymeIcon,
      },
      // {
      //   type: 'paymentMethod',
      //   value: 'alipay_cn',
      //   name: `${t('alipay')} CN`,
      // },
      {
        type: 'paymentMethod',
        value: 'wechat_pay',
        name: `${t('wechat_pay')}`,
        // icon: faWeixin,
        png: wechatIcon,
      },
      {
        type: 'paymentMethod',
        value: 'paypal',
        name: `${t('paypal')}`,
        // icon: faWeixin,
        png: paypalIcon,
      },
      {
        type: 'paymentMethod',
        value: 'paypal_auth',
        name: `${t('paypal_auth')}`,
        // icon: faWeixin,
        png: paypalIcon,
      },
      {
        type: 'paymentMethod',
        value: 'edda',
        name: `${t('edda')}`,
        // icon: faWeixin,
        png: eddaIcon,
      },
      // {
      //   value: 'credit_card',
      //   name: t('credit_card'),
      // },
    ]
    return [
      {
        type: 'paymentMethod',
        value: 'wallet',
        png: walletIcon,
        name: `${t('spc_wallet')} - $${moneyFormatter(user.wallet_balance)}`,
        // icon: faWallet,
      },
      ...supportMethods.filter((supportMethod) => {
        return (
          paymentServiceCharges.hasOwnProperty(supportMethod.value)
          && ((paymentServiceCharges[supportMethod.value].hasOwnProperty('enabled')
            && paymentServiceCharges[supportMethod.value].enabled)
            || (invoice.hasOwnProperty('payment_method')
              && supportMethod.value === invoice.payment_method))
        )
      }),
    ]
  }

  get paymentMethodsWithCreditCards() {
    const { paymentServiceCharges, invoice } = this.props
    if (
      paymentServiceCharges.hasOwnProperty('credit_card')
      && ((paymentServiceCharges.credit_card.hasOwnProperty('enabled')
        && paymentServiceCharges.credit_card.enabled)
        || (invoice.hasOwnProperty('payment_method') && invoice.payment_method === 'credit_card'))
    ) {
      return [
        ...this.paymentMethods,
        ...this.creditCards.map((cards) => {
          return {
            ...cards,
            type: 'creditCard',
          }
        }),
      ]
    }
    return this.paymentMethods
  }

  get totalItemsAmount() {
    const amount = this.items.reduce((totalAmount, item) => {
      return totalAmount + item.amount
    }, 0)
    return amount > 0 ? amount : 0
  }

  get paymentServiceChargeRate() {
    const { paymentMethod } = this.state
    const { invoice, paymentServiceCharges } = this.props
    if (
      invoice
      && (invoice.status === 'PAID' || invoice.status === 'CANCELLED')
      && Object.prototype.hasOwnProperty.call(invoice, 'payload')
      && Object.prototype.hasOwnProperty.call(invoice.payload || {}, 'serviceChargeRate')
      && Object.prototype.hasOwnProperty.call(
        invoice.payload || {},
        'schoolAffordPaymentServiceCharge',
      )
      && invoice.payload.schoolAffordPaymentServiceCharge === 'CHARGE_PARENT'
    ) {
      return invoice.payload.serviceChargeRate || 0
    }
    if (
      Object.prototype.hasOwnProperty.call(paymentServiceCharges, paymentMethod)
      && Object.prototype.hasOwnProperty.call(paymentServiceCharges[paymentMethod], 'rate')
    ) {
      return paymentServiceCharges[paymentMethod].rate
    }
    return 0
  }

  get paymentServiceFixCharge() {
    const { paymentMethod } = this.state
    const { invoice, paymentServiceCharges } = this.props
    if (
      invoice
      && (invoice.status === 'PAID' || invoice.status === 'CANCELLED')
      && Object.prototype.hasOwnProperty.call(invoice, 'payload')
      && Object.prototype.hasOwnProperty.call(invoice.payload || {}, 'fixCharge')
      && Object.prototype.hasOwnProperty.call(
        invoice.payload || {},
        'schoolAffordPaymentServiceCharge',
      )
      && invoice.payload.schoolAffordPaymentServiceCharge === 'CHARGE_PARENT'
    ) {
      return invoice.payload.fixCharge || 0
    }
    if (
      Object.prototype.hasOwnProperty.call(paymentServiceCharges, paymentMethod)
      && Object.prototype.hasOwnProperty.call(paymentServiceCharges[paymentMethod], 'fix_charge')
    ) {
      return paymentServiceCharges[paymentMethod].fix_charge
    }
    return 0
  }

  get serviceChargeAmount() {
    return (
      (this.totalItemsAmount + this.paymentServiceFixCharge) / (1 - this.paymentServiceChargeRate)
      - this.totalItemsAmount
    )
  }

  get totalAmount() {
    return this.totalItemsAmount + this.serviceChargeAmount
  }

  get items() {
    const { invoice } = this.props
    if (!invoice) {
      return []
    }
    if (
      (invoice.status === 'PAID' || invoice.status === 'CANCELLED')
      && Object.prototype.hasOwnProperty.call(invoice, 'payload')
      && Object.prototype.hasOwnProperty.call(invoice.payload || {}, 'items')
    ) {
      return invoice.payload.items
    }
    return invoice.items || []
  }

  get invoicePayMethodIndex() {
    const { invoice } = this.props
    const { paymentMethod, selectedCreditCardId } = this.state
    console.log('state paymentMethod', paymentMethod)
    let card_id = 0
    let currentMethod = 'wallet'
    switch (invoice.status) {
      case 'PENDING':
        currentMethod = paymentMethod
        card_id = selectedCreditCardId
        break
      default:
        currentMethod = invoice.payment_method ? invoice.payment_method : currentMethod
        card_id = currentMethod === 'credit_card' && invoice.hasOwnProperty('card_id')
          ? invoice.card_id
          : card_id
        break
    }

    const index = this.paymentMethodsWithCreditCards.findIndex((method) => {
      // eslint-disable-next-line
      return method.value === currentMethod || (card_id > 0 && method.value == card_id)
    })
    return index !== -1 ? index : 0
  }

  handleAddValueClick = () => {
    const { history, match } = this.props
    return history.push({
      pathname: `/school/${match.params.schoolCode}/user/wallet/addValue`,
      data: {
        amount: this.totalAmount,
      },
    })
  }

  handlePaymentMethodWithCreditCardChange = (value, index) => {
    const selectedItem = this.paymentMethodsWithCreditCards[index]
    const { type } = selectedItem
    if (type === 'paymentMethod') {
      this.handlePaymentMethodChange(value)
    } else if (type === 'creditCard') {
      this.handleCreditCardChange(value)
    }
  }

  handlePaymentMethodChange = (value) => {
    this.setState({
      paymentMethod: value,
      selectedCreditCardId: null,
    })
  }

  handleCreditCardChange = (value) => {
    const { history, match } = this.props
    if (value === 'NEW_CREDIT_CARD') {
      return history.push(`/school/${match.params.schoolCode}/user/wallet/credit_cards/add`)
    }
    return this.setState({
      paymentMethod: 'credit_card',
      selectedCreditCardId: value,
    })
  }

  handlePayeeNameChange = (value) => {
    this.setState({
      ...this.state,
      payeeName: value,
    })
  }

  handleSubmitButtonClick = () => {
    const { invoice, user } = this.props
    const { paymentMethod, selectedCreditCardId } = this.state
    if (paymentMethod === 'wallet' && user.wallet_balance < this.totalAmount) {
      this.setState({
        displayNotEnoughPopup: true,
      })
    }
    switch (paymentMethod) {
      case 'alipay_hk':
        this.props.fetchPaymentParams(invoice.id, 'ALIPAY_HK')
          .then(response => {
            if (response && response.pay_params_string) {
              this.handleAlipayPayment(response.pay_params_string);
            }
          });
        return
      case 'alipay_cn':
        this.props.fetchPaymentParams(invoice.id, 'ALIPAY_CN')
        return
      case 'wechat_pay':
        this.props.fetchPaymentParams(invoice.id, 'WECHAT')
        return
      case 'tng':
        this.props.fetchPaymentParams(invoice.id, 'TNG')
        return
      case 'fps_hase':
        this.props.fetchPaymentParams(invoice.id, 'FPS_HASE')
        return
      case 'payme':
        this.props.fetchPaymentParams(invoice.id, 'PAYME')
        return
      case 'paypal':
        this.props.fetchPaymentParams(invoice.id, 'PAYPAL')
        return
      case 'paypal_auth':
        this.props.fetchPaymentParams(invoice.id, 'PAYPAL_AUTH')
        return
      case 'edda':
        this.props.fetchPaymentParams(invoice.id, 'EDDA')
        return
      default:
        this.props.payInvoice(invoice.id, {
          payment_method: paymentMethod,
          card_id: selectedCreditCardId,
        })
    }
  }

  handleOtherPaymentMethodClick = () => {
    this.setState({
      displayNotEnoughPopup: false,
    })
  }

  static getDerivedStateFromProps(props, state) {
    if (
      state.displayPaySuccessPopup !== props.isPayInvoiceSuccess
      || state.displayQfPayFailedPopup !== props.isQfPayFailed
    ) {
      return {
        displayPaySuccessPopup: props.isPayInvoiceSuccess,
        displayQfPayFailedPopup: props.isQfPayFailed,
      }
    }
    return null
  }

  handleDisplaySuccessPopupDismiss = () => {
    const { match } = this.props
    const { id } = match.params
    this.props.fetchInvoice(id)
    this.setState({
      displayPaySuccessPopup: false,
    })
  }

  handleDisplaySuccessPopupButtonClick = () => {
    const { history, match } = this.props
    this.props.reset(PAY_INVOICE)
    this.props.reset(FETCH_PAYMENT_STATUS)
    this.setState({
      paymentMethod: 'wallet',
      displayPaySuccessPopup: false,
    })
    history.push(`/school/${match.params.schoolCode}/user/wallet`)
  }

  handleDisplayQfPayFailedPopupDismiss = () => {
    this.setState({
      displayQfPayFailedPopup: false,
    })
  }

  handleDisplayQfPayFailedPopupButtonClick = () => {
    // const { history } = this.props
    this.props.reset(FETCH_PAYMENT_STATUS)
    this.setState({
      displayQfPayFailedPopup: false,
    })
    // history.goBack()
  }

  handleValidatePayStatus = () => {
    const { match } = this.props
    const { id } = match.params
    this.props.reset(FETCH_PAYMENT_STATUS)
    this.props.fetchPaymentStatus(id)
  }

  handleChangeMethodButtonClick = () => {
    this.setState({ displayConfirmChangeMethodPopup: true })
  }

  confirmChangePaymentMethod = () => {
    const { match } = this.props
    const { id } = match.params
    this.props.changePayMethod(id)
    this.setState({ displayConfirmChangeMethodPopup: false })
  }

  cancelChangePaymentMethod = () => {
    this.setState({ displayConfirmChangeMethodPopup: false })
  }

  componentDidMount() {
    const { match } = this.props
    const { id } = match.params
    // hot fix for typo in iOS app (successa)
    ClientEventHandler.on(
      ClientEventHandlerProtocol.PAYMENT_STATUS_UPDATE,
      ({ success, successa }) => {
        console.log('Receive notify success from bridge', success)
        if (success || successa) {
          this.props.fetchPaymentStatus(id)
          return
        }
        this.props.reset(FETCH_PAYMENT_STATUS)
        this.props.reset(FETCH_PAYMENT_PARAMS)
        this.props.reset(FETCH_INVOICE)
        this.props.reset(FETCH_CREDIT_CARD)
        this.props.reset(PAY_INVOICE)
        this.props.fetchInvoice(id)
      },
    )
    this.props.reset(FETCH_PAYMENT_STATUS)
    this.props.reset(FETCH_PAYMENT_PARAMS)
    this.props.reset(FETCH_INVOICE)
    this.props.reset(FETCH_CREDIT_CARD)
    this.props.reset(PAY_INVOICE)
    this.props.fetchInvoice(id)
    this.props.fetchCreditCards()
    if (this.props.paymentServiceCharges.length === 0) {
      this.props.fetchPaymentServiceCharges()
    }
  }

  handleAlipayPayment = async (paymentUrl) => {
    try {
      // Check if we're running in a WebView
      const isInWebView = window.ReactNativeWebView;
      
      if (isInWebView) {
        // Send message to native app to open in default browser
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'ALIPAY_HK',
          url: paymentUrl
        }));
      } else {
        // Direct browser handling
        window.location.href = paymentUrl;
      }
    } catch (error) {
      console.error('Error handling Alipay payment:', error);
      this.setState({
        displayQfPayFailedPopup: true
      });
    }
  };

  handlePayment = async () => {
    try {
      const { paymentMethod } = this.state;
      const response = await this.props.payInvoice();

      if (paymentMethod === 'alipay_hk') {
        await this.handleAlipayPayment(response.paymentUrl);
      } else {
        // Handle other payment methods
        this.setState({
          paymentUrl: response.paymentUrl,
          showWebView: true
        });
      }
    } catch (error) {
      console.error('Payment error:', error);
      this.setState({
        displayQfPayFailedPopup: true
      });
    }
  };

  render() {
    const {
      displayNotEnoughPopup,
      displayPaySuccessPopup,
      displayQfPayFailedPopup,
      displayConfirmChangeMethodPopup,
      paymentMethod,
    } = this.state
    const {
      invoice,
      classes,
      isSubmitting,
      isFetchCreditCardSuccess,
      isFetchInvoiceSuccess,
      isPayInvoiceSuccess,
      isFetchPaymentServiceChargesSuccess,
      t,
    } = this.props
    return (
      <MobileWrapper overlay={true}>
        {displayNotEnoughPopup && (
          <PopupModal title={t('not_enough_value')} icon={cautionIcon}>
            <p style={{ textAlign: 'center' }}>{t('spc_wallet_not_enough_msg')}</p>
            <div className={classes.popupModalButtonContainer}>
              {/* <div className={classes.popupModalButton}> */}
              {/*  <StyleButton */}
              {/*    name={t('online_add_value')} */}
              {/*    styleType={'secondary'} */}
              {/*    onClick={this.handleAddValueClick} */}
              {/*  /> */}
              {/* </div> */}
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('other_payment_method')}
                  styleType={'secondary'}
                  onClick={this.handleOtherPaymentMethodClick}
                />
              </div>
            </div>
          </PopupModal>
        )}
        {displayPaySuccessPopup && (
          <PopupModal
            title={t('success')}
            icon={tickIcon}
            onDismiss={this.handleDisplaySuccessPopupDismiss}
          >
            <p style={{ textAlign: 'center' }}>{`${t('payment_success')}`}</p>
            <div className={classes.popupModalButtonContainer}>
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('ok')}
                  styleType={'secondary'}
                  onClick={this.handleDisplaySuccessPopupButtonClick}
                />
              </div>
            </div>
          </PopupModal>
        )}
        {displayQfPayFailedPopup && (
          <PopupModal
            title={t('fail')}
            icon={cautionIcon}
            onDismiss={this.handleDisplayQfPayFailedPopupDismiss}
          >
            {!['paypal', 'paypal_auth'].includes(paymentMethod)
              ? <p style={{ textAlign: 'center' }}>{`${t('payment_fail')}`}</p>
              : <p style={{ textAlign: 'center' }}>{`${t('paypal_validation_fail')}`}</p>}
            <div className={classes.popupModalButtonContainer}>
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('ok')}
                  styleType={'secondary'}
                  onClick={this.handleDisplayQfPayFailedPopupButtonClick}
                />
              </div>
            </div>
          </PopupModal>
        )}
        {displayConfirmChangeMethodPopup && (
          <PopupModal title={t('change_method')} icon={cautionIcon}>
            <p>{t('change_method_notice')}</p>
            <div className={classes.popupModalButtonContainer}>
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('change_method')}
                  styleType={'secondary'}
                  onClick={this.confirmChangePaymentMethod}
                />
              </div>
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('cancel')}
                  styleType={'secondary'}
                  onClick={this.cancelChangePaymentMethod}
                />
              </div>
            </div>
          </PopupModal>
        )}
        <MobileHeader
          title={t('invoice')}
          backAction={() => {
            const { history, match } = this.props
            history.push(`/school/${match.params.schoolCode}/user/wallet`)
          }}
        />
        <MobileContent>
          {!isFetchInvoiceSuccess && invoice && <LoadingSpinner />}
          {isSubmitting && invoice && <LoadingSpinner />}
          {!isSubmitting && isFetchInvoiceSuccess && invoice && (
            <div>
              {
                <WhiteBox
                  title={invoice.name || `${t('invoice_no')}${invoice.id}`}
                  description={
                    invoice.expired_at
                      ? `${t('payment_deadline')}: ${dateTimeFormatter(invoice.expired_at)}`
                      : ''
                  }
                  image={replySlipPaymentIcon}
                />
              }
              {invoice.status === 'PENDING' && moment().isAfter(invoice.expired_at) && (
                <div>
                  <p>{t('invoice_expired')}</p>
                </div>
              )}
              {invoice.status === 'PENDING'
                && !moment().isAfter(invoice.expired_at)
                && !isPayInvoiceSuccess && (
                  <div>
                    <div>
                      <p>{t('which_payment_method_msg')}</p>
                      <DropDownSelect
                        items={this.paymentMethodsWithCreditCards}
                        onItemChange={this.handlePaymentMethodWithCreditCardChange}
                        selectedIndex={this.invoicePayMethodIndex}
                      />
                    </div>
                    {invoice.expired_at && (
                      <div className={classes.deadlineContainer}>
                        <div className={classes.deadlineLabel}>{t('payment_deadline')}</div>
                        <div className={classes.deadlineText}>
                          {dateTimeFormatter(invoice.expired_at)}
                        </div>
                      </div>
                    )}
                  </div>
              )}
              {(invoice.status === 'PAYING'
                // || invoice.status === 'PAID'
                || invoice.status === 'CANCELLED')
                && !isPayInvoiceSuccess
                && invoice.payment_method
                && !(invoice.status === 'PAYING' && invoice.payment_method === 'fps_hase') && (
                  <div>
                    {invoice.status === 'PAYING' && <p>{t('invoice_paying_notice')}</p>}
                    {/* {invoice.status === 'PAID' && <p>{t('invoice_paid_notice')}</p>} */}
                    {invoice.status === 'CANCELLED' && <p>{t('invoice_cancel_notice')}</p>}
                    <div>
                      <DropDownSelect
                        items={this.paymentMethodsWithCreditCards}
                        onItemChange={this.handlePaymentMethodWithCreditCardChange}
                        selectedIndex={this.invoicePayMethodIndex}
                        disable={true}
                      />
                    </div>
                  </div>
              )}
              {invoice.status === 'PAYING' && invoice.payment_method === 'fps_hase' && invoice.payment_record && invoice.payment_record.extra && invoice.payment_record.extra.qrCode && (
                <div className={classes.fpsQrCodeContainer}>
                  <QrCode qrCodeString={invoice.payment_record.extra.qrCode} />
                  <div className={classes.fpsNameLabel}>
                    {t('fps_tutorial')}
                  </div>
                  <div className={classes.fpsNameLabel}>
                    {t('fps_paid_notice')}
                  </div>
                </div>
              )}
              {(invoice.status === 'PAID' || invoice.status === 'AUTH') && (
                <div>
                  <div className={classes.paidContainer}>
                    <div className={classes.paidIconContainer}>
                      <img
                        className={classes.paidIcon}
                        src={this.paymentMethodsWithCreditCards[this.invoicePayMethodIndex].png}
                        alt=""
                      />
                      <img
                        className={classes.paidTickIcon}
                        src={invoice.status === 'PAID' ? tickIcon : holdMoneyIcon}
                        alt=""
                      />
                    </div>
                  </div>
                  {invoice.status === 'PAID' ? (
                    <p>{t('invoice_paid_notice')}</p>
                  ) : (
                    <p>{t('invoice_auth_notice')}</p>
                  )}
                </div>
              )}
              <div style={{ marginTop: 16 }}>
                {this.items.map((item, index) => {
                  return (
                    <div className={classes.listItem} key={item.id}>
                      <div className={classes.listItemIconContainer}>
                        <div className={classes.listItemIcon}>{index + 1}</div>
                      </div>
                      <div className={classes.listItemContent}>
                        <div className={classes.listItemTitle}>{item.content}</div>
                        <div className={classes.listItemDescription}>
                          {item.sponsors && item.sponsors.length > 0 && (
                            <span className={classes.fontLineThrough}>
                              {`${t('hkd')} $${moneyFormatter(item.original_amount)}`}
                            </span>
                          )}
                          {`${t('hkd')} $${moneyFormatter(item.amount)}`}
                        </div>
                        {item.sponsors
                          && item.sponsors.map((sponsor) => {
                            return (
                              <div className={classes.listItem} key={sponsor.id}>
                                <div className={classes.listItemIconContainer} />
                                <div className={classes.listItemContent}>
                                  <div className={classes.listItemTitle}>{sponsor.name}</div>
                                  {sponsor.type === 'sponsor_amount' && (
                                    <div className={classes.listItemDescription}>{`${t(
                                      'hkd',
                                    )} $${moneyFormatter(sponsor.amount)}`}</div>
                                  )}
                                  {sponsor.type === 'sponsor_ratio' && (
                                    <div className={classes.listItemDescription}>{`${sponsor.amount
                                    } %`}</div>
                                  )}
                                </div>
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  )
                })}
              </div>
              <div className={classes.totalContainer}>
                <div className={classes.totalLabel}>{t('item_total')}</div>
                <div className={classes.totalAmount}>{`${t('hkd')}$${moneyFormatter(
                  this.totalItemsAmount,
                )}`}</div>
              </div>
              {this.serviceChargeAmount > 0.0 && (
                <div className={classes.totalContainer}>
                  <div className={classes.totalLabel}>{t('service_charge')}</div>
                  <div className={classes.totalAmount}>
                    {isFetchPaymentServiceChargesSuccess
                      && `${t('hkd')}$${moneyFormatter(this.serviceChargeAmount)}`}
                  </div>
                </div>
              )}
              {this.serviceChargeAmount > 0.0 && (
                <div className={classes.totalContainer}>
                  <div className={classes.totalLabel}>{t('total')}</div>
                  <div className={classes.totalAmount}>
                    {isFetchPaymentServiceChargesSuccess
                      && `${t('hkd')}$${moneyFormatter(this.totalAmount)}`}
                  </div>
                </div>
              )}
              {invoice.status === 'PENDING'
                && !moment().isAfter(invoice.expired_at)
                && !isPayInvoiceSuccess && (
                  <div className={classes.paymentButtonContainer}>
                    <div className={classes.paymentButton}>
                      <StyleButton
                        disabled={!isFetchCreditCardSuccess || isSubmitting || isPayInvoiceSuccess}
                        name={t('confirm')}
                        styleType={'secondary'}
                        onClick={this.handleSubmitButtonClick}
                      />
                    </div>
                  </div>
              )}
              {invoice.status === 'PAYING'
                && !moment().isAfter(invoice.expired_at)
                && !isPayInvoiceSuccess && (
                  <div className={classes.payingButtonContainer}>
                    {invoice.payment_method !== 'fps_hase'
                        && <div className={classes.payingButton}>
                            <StyleButton
                              name={t('manual_validate')}
                              styleType={'secondary'}
                              onClick={this.handleValidatePayStatus}
                            />
                          </div>
                    }
                    <div className={classes.payingButton}>
                      <StyleButton
                        name={t('change_method')}
                        styleType={'secondary'}
                        onClick={this.handleChangeMethodButtonClick}
                      />
                    </div>
                  </div>
              )}
            </div>
          )}
        </MobileContent>
      </MobileWrapper>
    )
  }
}

InvoicePage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
  }),
  classes: PropTypes.object,
  user: PropTypes.object,
  creditCards: PropTypes.array,
  paymentServiceCharges: PropTypes.array,
  isFetchInvoiceSuccess: PropTypes.bool,
  isFetchCreditCardSuccess: PropTypes.bool,
  invoice: PropTypes.object,
  fetchInvoice: PropTypes.func,
  payInvoice: PropTypes.func,
  reset: PropTypes.func,
  changePayMethod: PropTypes.func,
  fetchPaymentServiceCharges: PropTypes.func,
  fetchPaymentStatus: PropTypes.func,
  fetchPaymentParams: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isPayInvoiceSuccess: PropTypes.bool,
  isQfPayFailed: PropTypes.bool,
  isFetchPaymentServiceChargesSuccess: PropTypes.bool,
  fetchCreditCards: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  t: PropTypes.func,
}

export default withRouter(InvoicePage)
